import React from "react";
import StartupOnboraded from "./onboraded-details/StartupOnboraded";

const Scsthubavplist = ({ role }) => {
  return (
    <>
      <div className="scsthub-div form_div chart">
        <StartupOnboraded role={role} />
      </div>
    </>
  );
};

export default Scsthubavplist;
